module.exports = __webpack_public_path__ + "static/img/F1.8bff77b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/F1.png
// module id = VqcO
// module chunks = 1